"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SquareFeetSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SquareFeetSVG = function SquareFeetSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.39,25.56l-24-22A1.9767,1.9767,0,0,0,4.01,3H4A2.0048,2.0048,0,0,0,2,5V28a1.0029,1.0029,0,0,0,1,1H28a1.9917,1.9917,0,0,0,2-2A1.9163,1.9163,0,0,0,29.39,25.56ZM8,26.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0Zm5,0a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0ZM10,21V16l5,5Zm8,5.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0Zm5,0a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0Z"
  }));
};
exports.SquareFeetSVG = SquareFeetSVG;
SquareFeetSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SquareFeetSVG);
exports.default = _default;